/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import Cursoplay from './Cursoplay';
import {bindActionCreators} from 'redux';
import * as tagActions from '../../actions/tagActions';
import * as crucigramaActions from '../../actions/crucigramaActions';
import * as formularioActions from '../../actions/formularioActions';
import * as resultadoexamenActions from '../../actions/resultadoexamenActions';
import * as comentariosActions from '../../actions/comentariosActions';
import * as contenidoActions from '../../actions/contenidoActions';
import * as crucigramapalabrasActions from '../../actions/crucigramapalabrasActions';
import CustomInput from './CustomInput'
import ModalComentarios from './ModalComentarios';
import { withAuthenticator } from '@aws-amplify/ui-react'
import {  useParams } from "react-router-dom";
import withRouter from '../common/withRouter';


import toastr from 'toastr';
import ManageList from '../common/ManageList';

import { Segment, Header} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as Resultado from '../common/Resultado';

import * as infoActions from '../../actions/infoActions';


import {usuarioActual, renuevaToken, validaApiToken} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';

import {getMargenes} from '../../util/';
import moment from 'moment';



import RichTextEditor from 'react-rte';

class ManageCursoplay extends React.Component {
    constructor(props, context) {
		
		super(props, context);
        
        this.referencia = React.createRef();
        
        
         let rows=[
        {id:1,
         icon:'file pdf outline',
         time:'15 min.',
        color:"red",
        desc:'Lidera programas de hemovigilancia institucional'},
        {id:2,
         icon:'youtube play',
         time:'15 min.',
         color:"red",
        desc:'Interpreta claramente los resultados de pruebas inmunohematológicas'},
        {id:3,
         icon:'address card outline',
         time:'15 min.',
         color:"teal",
        desc:'Toma decisiones asertivas para la resolución de casos complejos'},
        {id:4,
         icon:'chess board',
         time:'15 min.',
         color:"blue",
        desc:'Pon en marcha buenas prácticas en procedimientos de laboratorio de inmunohematología'},
        {id:5,
         icon:'tasks',
         time:'15 min.',
         color:"green",
        desc:'Crea redes de trabajo cooperativo con colegas de toda latinoamérica'},
        
             
             {id:6,
         icon:'tasks',
         time:'15 min.',
         color:"green",
        desc:'Crea redes de trabajo cooperativo con colegas de toda latinoamérica'},
        
 {id:7,
         icon:'video',
         time:'30 min.',
         color:"teal",
        desc:'Crea redes de trabajo cooperativo con colegas de toda latinoamérica'},
        

    ];
      
    let modulos=[
        {id:1,
        titulo:"Módulo 1: Bases de inmunohematologia",
        contenido:rows,
         min:45,
         activo:false
         
        },
        {id:2,
        titulo:"Módulo 2: Pruebas Pretransfusionales",
        contenido:rows,
         min:55,
         activo:false
        }
        ,
        {id:3,
        titulo:"Módulo 3: Anemias Hemoliticas",
        contenido:rows,
         min:140,
         activo:false
        },
        {id:4,
        titulo:"Módulo 4: Sistemas de Grupos sanguíneos",
        contenido:rows,
         min:30,
         activo:false
        }
        
    ];
      
        
        this.state={
            errors:{},
            strings:{},
            curso:{
                 modulos:[]
             },
            modulos:modulos,
            showActivos:true,
            showModal:false,
            filtrosCombo:{},
            permisos:{},
            examenSave:{
                cadena:[]
            },
            quiz:{
                
                questions:[]
            },
            err:null,
            appLocale:{
                "singleSelectionTagText":"Seleccion simple",    
                "multipleSelectionTagText":"Selección multiple",  
                "pickNumberOfSelection":"Selecciona <numberOfSelection>",
                "resultPagePoint": "Obtuviste <correctPoints> de un total de <totalPoints>.",
                "landingHeaderText": "La siguiente prueba consta de <questionLength> Preguntas",
                "question": "Pregunta",
                "startQuizBtn": "Comenzar prueba",
                "resultFilterAll": "All",
                "resultFilterCorrect": "Correct",
                "resultFilterIncorrect": "Incorrect",
                "nextQuestionBtn": "Siguiente",
                "resultPageHeaderText": "Tu has completado la prueba. Tuviste <correctIndexLength> correctas de <questionLength> preguntas."
                } ,
            comentarios:[],
            reply:0,
            edit:0,
            editReply:0,
            indexReply:-1,
            indexComentario:-1,
            textComment:"",
            visible:true, 
            fechaActual: new moment(),
            tiempoVideo:0,
            //value: RichTextEditor.createValueFromString('<p>hola</p><p>hola</p>','html')
            value: RichTextEditor.createEmptyValue(),
            fechaComentario:new moment().subtract(5, "days"),
            botonComentario:false,
            datatmp:{
                across:{},
                down:{}
            },
            
            dataCrucigrama:{
              across: {},
              down: {}
            },
            
            dataArray:[
              
            ],
            datos:{imagePreviewUrl:''}
            
		};
	}

    
    
    
    
	componentDidMount(){
        
        
       usuarioActual(this, "cursoplay",true).then( (usuario)=>{
           	//let id=this.props.id;
            let id=this.props.id;
        

            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
        
            if(id && id>0 ){
            
            this.props.infoActions.getCursoDetalle(id).then( (cursoDetalle)=>{
            let modulos=cursoDetalle.modulos;
            let contenido;
            let agrupador="";
            let fecha="";
            let contenidoViewRow={};
            let contenidoView=[];
            for(let k=0; k<modulos.length; k++){
                contenidoView=[];
                contenido=modulos[k].contenido;
                agrupador="";
                fecha="";
                for(let i=0; i<contenido.length;i++){
                    
                    contenido[i].fecha2 = new moment(contenido[i].fecha2.fecha2); 
                    
                    if(agrupador!=contenido[i].agrupador || fecha!=contenido[i].fecha){
                        if(i>0){
                            contenidoView.push(contenidoViewRow);
                        }
                        agrupador=contenido[i].agrupador;
                        fecha=contenido[i].fecha;
                        contenidoViewRow={
                            agrupador:contenido[i].agrupador,
                            fecha:contenido[i].fecha,
                            contenido:[]
                        };
                        
                    }
                    contenidoViewRow.contenido.push(contenido[i]);
                     
                }
                contenidoView.push(contenidoViewRow);
                 modulos[k].contenidoView=contenidoView;
            }
            
            this.setState({"curso":cursoDetalle});  
        })
        .catch(error=>{
          toastr.error(error);
        }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
        
        //this.interval = setInterval(this.getData, 1000);
        
        
	}
    
    getData=()=> {
        //do something to fetch data from a remote API.
        //console.log("consultando");
        //this.setState({fechaActual:this.state.fechaActual.add(1,'seconds')});
    }
    
    /*
    componentWillUnmount() {
        // Clear the interval right before component unmount
        clearInterval(this.interval);
    }
    */
        
  onAcordionModulo=(id)=>{
         
         let curso=this.state.curso;
        let modulos=curso.modulos;
        for(let i=0; i<modulos.length; i++){
            if(modulos[i].id==id){
                if(modulos[i].activo==null)
                    modulos[i].activo=true;
                else
                    modulos[i].activo=!modulos[i].activo;
            }
        }
        this.setState({"curso":curso});
    }
    
  onVisible=(id)=>{
      
        let encontrado=false;
        let curso=this.state.curso;
        let modulos=curso.modulos;
        let contenido;
        
        for(let k=0; k<modulos.length && encontrado==false; k++){
            if(modulos[k].activo==true){
                contenido=modulos[k].contenido;
                
                for(let i=0; i<contenido.length; i++){
                    if(contenido[i].id==id){
                        encontrado=true;
                        this.setState({
                            "idContenido":contenido[i].id,
                            "idModulo":modulos[k].id,
                            "tituloContenido":contenido[i].titulo,
                            "idTipoContenido":contenido[i].idTipoContenido,
                            "urlContenido":contenido[i].archivo,
                            "idVisible":id,
                            "errorEx":null,
                            "visible":false,
                            "idFormulario":contenido[i].idFormulario,
                            "idModuloContenido":contenido[i].idModuloContenido,
                            "time":contenido[i].time,
                            "secondsTime":(contenido[i].time),
                            "tiempoVideo":contenido[i].tiempoVideo}
                            );
                        if(contenido[i].visto!=true){
                            
                            if(contenido[i].idTipoContenido!=28){
                                contenido[i].visto=true;
                            }
                            
                            let contenidoVisto={
                                idCurso:this.state.curso.id,
                                idContenido:contenido[i].idModuloContenido,
                                visto:1
                            };
                            
                            this.setState({contenidoVisto:contenidoVisto});
                             
                             if(contenido[i].idTipoContenido!=28){         
                                    validaApiToken(this).then( (userToken)=>{
                                        this.props.cursoActions.setVisto(contenidoVisto, userToken).then( ()=>{

                                        }).catch(error=>{
                                              toastr.error(error);
                                        }); 

                                    })
                             }

                        }


                        if(contenido[i].idTipoContenido==28){

                            validaApiToken(this).then( (userToken)=>{
                            this.props.formularioActions.getExamen(contenido[i].idFormulario,this.state.curso.id, userToken).then( examen=>{
                              
                                if(examen.id>0){
                                    examen.appLocale = this.state.appLocale;
                                    for(let i=0; i<examen.questions.length; i++){
                                        if(examen.questions[i].answerSelectionType=="single"){

                                                examen.questions[i].correctAnswer = examen.questions[i].correctAnswer[0].toString();
                                        }

                                    }
                                }


                                this.setState({"quiz":examen}); 
                                 })
                                .catch(error=>{
                                  toastr.error(error);
                                });    
                            
                                 

                        })
    
                        }
                        
                         if(contenido[i].idTipoContenido==32){

                            validaApiToken(this).then( (userToken)=>{
                                
                                
                                this.props.crucigramapalabrasActions.getCrucigrama(contenido[i].juego, userToken).then( palabras=>{
                 
                                    this.convert(palabras);

                                 });
                                
                                
                                 })
                                .catch(error=>{
                                  toastr.error(error);
                                });    
                            
                                 

                        }    
                            
                    }

                    
        
                }

                
            }
        
        }
      
  }
      
      
  convert=(palabras)=>{
        let datatmp = Object.assign({}, this.state.datatmp);
        let dataArray=[];
       
        dataArray = palabras;
        
        
        
        for(let i=0; i<dataArray.length;i++){
            
            if(dataArray[i].posicion=="across"){
                let tmp = dataArray[i];  
                datatmp.across[eval(dataArray[i].num)] = { clue: tmp.clue, answer: tmp.answer, row: tmp.row, col: tmp.col};
            }    
        }
        
        for(let i=0; i<dataArray.length;i++){
            if(dataArray[i].posicion=="down"){
                let tmp = dataArray[i];    
                datatmp.down[eval(dataArray[i].num)] = { clue: tmp.clue, answer: tmp.answer, row: tmp.row, col: tmp.col};
            }
        }
        
        this.setState({dataCrucigrama:datatmp});
        this.setState({dataArray:palabras});
      
    }      
      
  
  
  setQuizResult = (obj) => {
      let objeto = Object.assign({},this.state.examenSave);

      if(obj.totalPoints>0){
        objeto.cadena = Object.assign({},obj);  
        objeto.idFormulario = this.state.idFormulario;
        objeto.idModuloContenido = this.state.idModuloContenido;
        objeto.idCurso = this.state.curso.id;
        objeto.correctPoints = obj.correctPoints;
        objeto.numberOfCorrectAnswers = obj.numberOfCorrectAnswers;
        objeto.numberOfIncorrectAnswers = obj.numberOfIncorrectAnswers;
        objeto.numberOfQuestions = obj.numberOfQuestions;
        objeto.totalPoints = obj.totalPoints;  
          
            validaApiToken(this).then( (userToken)=>{
                if(userToken!=null){
                    this.props.resultadoexamenActions.save(objeto, userToken).then(() => {
                        toastr.success("Examen guardado!!!.");
                        let errorEx=false;
                        this.setState({err:errorEx});   
                       
                        validaApiToken(this).then( (userToken)=>{
                            
                                let contenidoVisto={
                                    idCurso:this.state.curso.id,
                                    idContenido:this.state.idModuloContenido,
                                    visto:1
                                };
                            
                                this.props.cursoActions.setVisto(contenidoVisto, userToken).then( ()=>{

                                }).catch(error=>{
                                      toastr.error(error);
                                }); 

                            })
                        
                        let encontrado=false;
                        let curso=this.state.curso;
                        let modulos=curso.modulos;
                        let contenido;
                        
                        for(let k=0; k<modulos.length && encontrado==false; k++){
                            if(modulos[k].activo==true){
                                contenido=modulos[k].contenido;

                                for(let i=0; i<contenido.length; i++){
                                
                                    if(contenido[i].id==this.state.idContenido){  
                                        contenido[i].visto=true;
                                    }
                                }
                            }
                        }
                        
                    }).catch(error=>{
                        let errorEx=true;
                        this.setState({err:errorEx});
                        this.setState({objeto:objeto});
                        toastr.error("Hubo un errro al guardar su examen");
                    });
                }    
            })
            .catch(error=>{
                toastr.error(error);
                
            });

            
      }
  }
  
  onSeek=(segundos)=>{
      //console.log("onSeek: "+segundos);
  }
  
  onVideoTerminado=()=>{
      
        let contenidoVisto={
            idCurso:this.state.curso.id,
            idContenido:this.state.idModuloContenido,
            tiempoVideo:Math.round(this.state.duration)
        };
     
        renuevaToken(this, contenidoVisto);
      
  }
  
  
  videoProgreso=(progreso)=>{   
     
      //console.log("progreso");
      //console.log(progreso);
        
      
      
      if(this.state.tiempoVideo<= Math.floor(progreso.playedSeconds)){
          let avance=progreso.playedSeconds-this.state.tiempoVideo;
      
          
          if(avance>5)
          {             

              if(this.state.curso.avancePermitido!=1)
              {
                  const node = this.referencia.current;
                  node.seekTo(this.state.tiempoVideo);
                  toastr.error("Avance no permitido");
                }          
          }else{
              if(Math.floor(progreso.playedSeconds)>this.state.tiempoVideo){
                this.setState({"tiempoVideo":Math.floor(progreso.playedSeconds)});
              }  
          }
          
      }
      
      if((Math.floor(progreso.playedSeconds) % 180) ==0 && Math.floor(progreso.playedSeconds)!=0){
            
            
                let contenidoVisto={
                    idCurso:this.state.curso.id,
                    idContenido:this.state.idModuloContenido,
                    tiempoVideo:Math.floor(progreso.playedSeconds)
                };
                
                renuevaToken(this, contenidoVisto);
                
                    
      }
      
        /*
      let total = this.state.secondsTime;
      let saveTimes = 0;
      let parcial = 0;
    
      if(total<=600){
          saveTimes=3;
          
      }else if(total>600&& total <=1800){
          saveTimes=9;
      }else if(total>1800&& total <=3600){
          saveTimes=15;
      }else if(total>3600){
          saveTimes=21;
      }
      
      parcial = Math.floor(total/saveTimes);
      
      for(let i=1; i<=saveTimes;i++){
          if((parcial*i)==Math.floor(progreso.playedSeconds)){
              let contenidoVisto={
                idCurso:this.state.curso.id,
                idContenido:this.state.idModuloContenido,
                tiempoVideo:Math.floor(progreso.playedSeconds)
              };
              
              this.props.cursoActions.setVisto(contenidoVisto, this.props.user).then( ()=>{
                   
                   this.setState({tiempoVideo:contenidoVisto.tiempoVideo});

                }).catch(error=>{
                      toastr.error(error);
                });
              
              renuevaToken(this, contenidoVisto);
              
          }
      }
      */
      
  }
  
  
  renderCustomResultPage = (obj) => {
      let quiz = this.state.quiz;
        return (
            <Segment  style={{width: '100%', height:'80%'}}>
                <Header as='h3'>{quiz.quizTitle}</Header>

                Total de preguntas:{obj.numberOfQuestions}<br/>
                Correctas:{obj.numberOfCorrectAnswers}<br/>
                Incorrectas:{obj.numberOfIncorrectAnswers}<br/>
                Total de puntos posibles:{obj.totalPoints}<br/>
                Total obtenido:{obj.correctPoints}<br/>



            </Segment>    
        );
  }
  
  handleClick=(url, id)=>{
      
    let curso=this.state.curso;
    let modulos=curso.modulos;
    let contenido;
      
      for(let k=0; k<modulos.length; k++){
            if(modulos[k].activo==true){
                contenido=modulos[k].contenido;
                
                for(let i=0; i<contenido.length; i++){
                    if(contenido[i].id==id){
                        if(contenido[i].visto!=true){
                            contenido[i].visto=true;
                            let contenidoVisto={
                                idCurso:this.state.curso.id,
                                idContenido:contenido[i].idModuloContenido,
                                visto:10
                            };
                             
                                 
                            validaApiToken(this).then( (userToken)=>{
                                this.props.cursoActions.setVisto(contenidoVisto, userToken).then( ()=>{

                                }).catch(error=>{
                                      toastr.error(error);
                                }); 
                             
                            })        

                        }
                    }
                }
            }
      }
      
      
       window.open(url);
      
  }
  
  handleStateNewComment=(id)=>{
       
        this.setState({botonComentario:true});
        
        //console.log(this.state.textComment.length);
      
        if(this.state.textComment.length>10){
      
        let nuevoComment = {text: this.state.textComment, comId:id};
        let comentarios=[];
        let datos = this.state.datos;
        let upImage = 0;
        comentarios.foro =[];
        comentarios.foro.push(nuevoComment);
        comentarios.contenidoId = this.state.contenidoId;
        comentarios.idCurso=this.props.id;
        comentarios.idModuloContenido = this.state.idModuloContenido;
        
       
        validaApiToken(this).then( (userToken)=>{
                this.props.comentariosActions.saveComment(comentarios, userToken).then( comentarios=>{
                        let com = this.state.comentarios;    
                        let imagenAlmacenada;
                    
                        /*UPLOAD IMAGE*/
                    
                    
                        var adjunto=this.state.adjunto;
        
                        if(adjunto instanceof File){
                            var form_data = new FormData();
                            form_data.append('file', adjunto);
                            
                            if(datos.replay==0){
                                form_data.append('replay',datos.replay);
                                form_data.append('comId', comentarios.foro[0].comId);
                            }else{
                                form_data.append('replay',datos.replay);
                                form_data.append('comId', comentarios.foro[0].replies[0].comId)
                            }
                            
                            this.props.comentariosActions.saveImagen(form_data, userToken).then((imagen) => {
                                    toastr.success("Archivo guardado!!!.");
                                    upImage=1;
                                    imagenAlmacenada = imagen;
                                
                                
                                
                                       this.setState({reply:0});
                                        /********************** SOLO ES PARA QUE REFRESQUE ***********************/
                                        if(id==0){
                                             comentarios.foro[0].value = RichTextEditor.createValueFromString(comentarios.foro[0].text,'html');
                                             if(upImage==1)
                                                comentarios.foro[0].imagePreviewUrl = imagenAlmacenada.descripcion;
                                             com.push(comentarios.foro[0]);
                                        }else{
                                            let comIndex = com.findIndex(com=>com.comId==comentarios.foro[0].comId);
                                            comentarios.foro[0].replies[0].value = RichTextEditor.createValueFromString(comentarios.foro[0].replies[0].text,'html');
                                            if(upImage==1)
                                               comentarios.foro[0].replies[0].imagePreviewUrl = imagenAlmacenada.descripcion;

                                            com[comIndex].replies.push(comentarios.foro[0].replies[0]);

                                        }
                                        this.setState({value: RichTextEditor.createEmptyValue()});
                                        this.setState({textComment:""});
                                        this.setState({comentarios:com});
                                        this.setState({botonComentario:false});  
                                        this.setState({datos:[]});
                                        /********************** SOLO ES PARA QUE REFRESQUE ***********************/
                                

                                    this.setState({"adjunto": ""});
                                }).catch(error=>{
                                  toastr.error(error.responseJSON.message);
                                });


                        }else{
                    
                        /**************/
                    
                    
                    
                            this.setState({reply:0});

                            if(id==0){
                                 comentarios.foro[0].value = RichTextEditor.createValueFromString(comentarios.foro[0].text,'html');
                                 if(upImage==1)
                                    comentarios.foro[0].imagePreviewUrl = imagenAlmacenada.descripcion;
                                 com.push(comentarios.foro[0]);
                            }else{
                                let comIndex = com.findIndex(com=>com.comId==comentarios.foro[0].comId);
                                comentarios.foro[0].replies[0].value = RichTextEditor.createValueFromString(comentarios.foro[0].replies[0].text,'html');
                                if(upImage==1)
                                   comentarios.foro[0].replies[0].imagePreviewUrl = imagenAlmacenada.descripcion;

                                com[comIndex].replies.push(comentarios.foro[0].replies[0]);

                            }
                            this.setState({value: RichTextEditor.createEmptyValue()});
                            this.setState({textComment:""});
                            this.setState({comentarios:com});
                            this.setState({botonComentario:false});
                            this.setState({datos:[]});
                    
                        }        
                    
                    
                
                
                })
                    .catch(error=>{
                      toastr.error(error);
                });
        })
        .catch(error=>{
          toastr.error(error);
        });
       
        }else{
            
            toastr.error("Debe capturar un comentario");
            
        }
  }
  
  addText=(event, data)=>{
        //addText=(editorState)=>{
        //console.log(editorState);
        //this.setState({editorState:editorState});
        //console.log(data);
        this.setState({textComment:data.value});      
  }
  
  
   handleState=(value)=>{
        
        this.setState({comentarios:value})
        
        let comentarios=[];
       
        for(let i=0; i<value.length; i++){
            
            if(isNaN(value[i].comId)){
               value[i].comId=0;
            }
            
            if(value[i].replies){
                
                for(let j=0; j<value[i].replies.length; j++){
                    
                    if(isNaN(value[i].replies[j].comId)){
                           value[i].replies[j].comId=0;
                        } 
                    
                }
                
            }
            
        }
        
        comentarios.foro = value;
        comentarios.contenidoId = this.state.contenidoId;
        comentarios.idCurso=this.props.id;
        comentarios.idModuloContenido = this.state.idModuloContenido;
       
        comentarios.id = this.state.idComentarios;
       
        validaApiToken(this).then( (userToken)=>{
                //this.props.comentariosActions.save(comentarios, this.props.user).then( comentarios=>{
                this.props.comentariosActions.save(comentarios, userToken).then( comentarios=>{    

                        //this.setState({idComentarios:comentarios.id});
                        this.setState({"comentarios":comentarios.foro});
                     })
                    .catch(error=>{
                      toastr.error(error);
                });
        });
        
    }
   
    customInputFunc = (props) => {
        return <CustomInput parentId={props.parentId}
          cancellor={props.cancellor}
          value={props.value}  edit={props.edit}
          submit={props.submit} handleCancel={props.handleCancel}/>
      }
  
  regresar=()=>{
   
      let curso=this.state.curso;
      let modulos=curso.modulos;
      let quiz = {};
      let errorEx=null;
      quiz.id = 0;
      
      
      let moduloIndex = modulos.findIndex(modulo=>modulo.id==this.state.idModulo);
      
      let contenidoIndex = modulos[moduloIndex].contenido.findIndex(cont=>cont.id==this.state.idContenido);
      
      
      if(curso.modulos[moduloIndex].contenido[contenidoIndex].tiempoVideo < this.state.tiempoVideo){
          curso.modulos[moduloIndex].contenido[contenidoIndex].tiempoVideo = this.state.tiempoVideo;
          /*
          let contenidoVisto={
                idCurso:this.state.curso.id,
                idContenido:this.state.idModuloContenido,
                tiempoVideo:this.state.tiempoVideo
              };
          
           renuevaToken(this, contenidoVisto);
          */
      }
      
      this.setState({
                    "visible":true, "curso":curso, "quiz":quiz });
      this.setState({err:errorEx});
      
      /*
      this.setState(function (prevState) {
        return {
            visible: !prevState.visible
        };
    });*/
  }
  
  
    showModalComents=(id, idModuloContenido)=>{
        
        
       
        let idCurso=this.props.id;
        //console.log(idCurso);
        
        let datos=this.state.datos;
        datos['imagePreviewUrl'] = '';
        this.setState({"contenidoId":id, "idModuloContenido":idModuloContenido, datos:datos});
        
        validaApiToken(this).then( (userToken)=>{
         
            //this.props.comentariosActions.getComentarios(id, idCurso, this.props.user).then( comentarios=>{
            this.props.comentariosActions.getComentarios(id, idCurso, userToken).then( comentarios=>{
                let idComentarios;
                let coments;
                if(comentarios.cadena == null){
                    //coments=[];
                    idComentarios=-1;
                }else{
                    //coments = comentarios.foro;
                    idComentarios = comentarios.id;

                }
                
                for(let i=0;i<comentarios.foro.length;i++){
                    comentarios.foro[i].value = RichTextEditor.createValueFromString(comentarios.foro[i].text,'html');
                    if(comentarios.foro[i].imageUrl!=null)
                        comentarios.foro[i].imagePreviewUrl = comentarios.foro[i].imageUrl;
                    else
                        comentarios.foro[i].imagePreviewUrl = '';
                    
                    for(let j=0;j<comentarios.foro[i].replies.length;j++){
                        comentarios.foro[i].replies[j].value = RichTextEditor.createValueFromString(comentarios.foro[i].replies[j].text,'html');   
                        
                        if(comentarios.foro[i].replies[j].imageUrl!=null)
                            comentarios.foro[i].replies[j].imagePreviewUrl = comentarios.foro[i].replies[j].imageUrl;
                        else
                            comentarios.foro[i].replies[j].imagePreviewUrl = '';
                        
                        
                    }
                }
                
                    this.setState({"value": RichTextEditor.createEmptyValue()});
                    this.setState({"fullName":comentarios.fullName});
                    this.setState({"userId":comentarios.userId});
                    this.setState({idComentarios:idComentarios});
                    this.setState({"comentarios":comentarios.foro});
                    this.setState({textComment:""});

            })
            .catch(error=>{
              toastr.error(error);
            });        

         });
        
        this.setState({textComment:""});
        this.setState({showModal:!this.state.showModal});
        
    }
    
    
    
    
    handleDuration = (duration) => {
            this.setState({duration:duration});
            if(this.state.secondsTime!=null){
                if(this.state.secondsTime!=Math.round(duration)){
                    
                    let contenido={};
                    contenido.id = this.state.idContenido;
                    contenido.tiempo = Math.round(duration);
                    
                    validaApiToken(this).then( (userToken)=>{
                        this.props.contenidoActions.saveTime(contenido,userToken).then(() => {

                        });
                    });
                    
                }            
            }
    }
    
    saveExamen=()=>{
        
        
        validaApiToken(this).then( (userToken)=>{
                if(userToken!=null){
                    this.props.resultadoexamenActions.save(this.state.objeto, userToken).then(() => {
                        toastr.success("Examen guardado!!!.");
                         let errorEx=false;
                        this.setState({objeto:""});
                        this.setState({err:errorEx});
                        
                        
                        validaApiToken(this).then( (userToken)=>{
                                //console.log(this.state.idModuloContenido);
                                let contenidoVisto={
                                    idCurso:this.state.curso.id,
                                    idContenido:this.state.idModuloContenido,
                                    visto:1
                                };
                            
                                this.props.cursoActions.setVisto(contenidoVisto, userToken).then( ()=>{

                                }).catch(error=>{
                                      toastr.error(error);
                                }); 

                            })
                        
                        let encontrado=false;
                        let curso=this.state.curso;
                        let modulos=curso.modulos;
                        let contenido;
                        
                        for(let k=0; k<modulos.length && encontrado==false; k++){
                            if(modulos[k].activo==true){
                                contenido=modulos[k].contenido;

                                for(let i=0; i<contenido.length; i++){
                                
                                    if(contenido[i].id==this.state.idContenido){  
                                        contenido[i].visto=true;
                                    }
                                }
                            }
                        }
                        
                        
                    }).catch(error=>{
                        let errorEx=true;
                        this.setState({err:errorEx});
                        
                        toastr.error("Hubo un errro al guardar su examen");
                    });
                }    
            });
        
        
        
        
        
        let errorEx=false;
        this.setState({err:errorEx});    
        
    }
    
    onReply=(id)=>{
        this.setState({value:RichTextEditor.createEmptyValue()});
        this.setState({textComment:""});
        this.setState({reply:id});
    }
    
    
    onEditar=(id)=>{
        
        let comentarios = this.state.comentarios;
        let indexComentario = comentarios.findIndex(com=>com.comId==id);
        this.setState({edit:id, indexComentario:indexComentario});
        
    }
    
    
     onContentEdit=(value)=>{
        let comentarios = this.state.comentarios;
        comentarios[this.state.indexComentario].value =  value;
        comentarios[this.state.indexComentario].text = value.toString('html');
        this.setState({comentarios:comentarios});
        
    }
     
     
    onEditarReply=(comentId, id)=>{
        let comentarios = this.state.comentarios;
        let indexComentario = comentarios.findIndex(com=>com.comId==comentId);
        let indexReply =comentarios[indexComentario].replies.findIndex(rep=>rep.comId==id);
        this.setState({editReply:id, indexReply:indexReply, indexComentario:indexComentario});
        
    }
    
    
     onReplyEdit=(value)=>{
        let comentarios = this.state.comentarios;
        comentarios[this.state.indexComentario].replies[this.state.indexReply].value =  value;
        comentarios[this.state.indexComentario].replies[this.state.indexReply].text = value.toString('html');
        this.setState({comentarios:comentarios});
        
    } 
     
    closeModalComents=(id)=>{

        this.setState({"comentarios":[], contenidoId:0, idModuloContenido:0});
        this.setState({idComentarios:-1});
        this.setState({showModal:!this.state.showModal});
        this.setState({textComment:""});
        this.setState({edit:0, editReply:0 , indexComentario:-1}); 
        
    } 
     
     
     onSaveReply=()=>{
        
        let reply = Object.assign({}, this.state.comentarios[this.state.indexComentario].replies[this.state.indexReply]);
      
        validaApiToken(this).then( (userToken)=>{

            this.props.comentariosActions.editarReplay(reply, userToken).then(() => {
                toastr.success("Respuesta actualizada")
                this.setState({editReply:0, indexComentario:-1, indexReply:-1}); 

            })
            .catch(error=>{
            });
             
        });
        
    } 
     
     
    onSaveComent=()=>{
        
        let comentario = Object.assign({}, this.state.comentarios[this.state.indexComentario]);
        validaApiToken(this).then( (userToken)=>{

            this.props.comentariosActions.editarComentario(comentario, userToken).then(() => {
                toastr.success("Comentario actualizado")
                this.setState({edit:0, indexComentario:-1}); 

            })
            .catch(error=>{
            });
             
        });     
    }
    
    handleComentarioDelete=(comentarioId)=>{
        
         validaApiToken(this).then( (userToken)=>{

                this.props.comentariosActions.borrar(comentarioId, userToken).then(() => {
                    toastr.success("Comentario borrado")
                    
                    let comentarios = this.state.comentarios;
                    comentarios = comentarios.filter(com=>com.comId!=comentarioId);
                    this.setState({comentarios:comentarios});
                    
                })
                .catch(error=>{
                });
        });
        
        
    }
    
    handleReplyDelete=(comentarioId, id)=>{
    
      
        validaApiToken(this).then( (userToken)=>{

                this.props.comentariosActions.replyDelete(id, userToken).then(() => {
                    toastr.success("Respuesta a comentario borrada")

                    let comentarios = this.state.comentarios;
                    let indexComentario = comentarios.findIndex(com=>com.comId==comentarioId);
                    let indexRaply = comentarios[indexComentario].replies.findIndex(rep=>rep.comId==id);
                    let replies = comentarios[indexComentario].replies.filter(r=>r.comId != id)

                    comentarios[indexComentario].replies=replies;

                    this.setState({comentarios:comentarios});
                })
                .catch(error=>{
                });
        });
    }
    
    onCancelReply=()=>{
        
        let datos = this.state.datos;
        datos['imagePreviewUrl']="";
        this.setState({textComment:"", datos:datos});
        this.setState({value:RichTextEditor.createEmptyValue()});
        this.setState({reply:0});
    }
   
    setContent=(value)=>{
        this.setState({textComment:value.toString('html')});
        this.setState({value:value});
    }
    
    
    onChange=(event, data)=> {	
        let datos = this.state.datos;
        let field= data.name;		
        let value=	data.value;		
        
        if(data.type == 'file'){
             
            let file = event.target.files[0];
            if (!file){
                return;
            }
           
            
            var Extension = event.target.files[0].name.substring(
                    event.target.files[0].name.lastIndexOf('.') + 1).toLowerCase();

            if (!(Extension == "png" || Extension == "bmp"
                    || Extension == "jpeg" || Extension == "jpg")) {
                
                toastr.error("Solo se permiten imagenes de tipo jpeg, png, jpg y bmp!!!");
                return;
            }
         
            if(event.target.files[0].size<=2097152){
                
                this.setState({"adjunto": event.target.files[0]}); 
                datos['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
                if(field=='adjunto_replay'){
                    datos['replay']=1;
                }else{
                    datos['replay']=0;
                }
            }else{
                
                toastr.error("No se permiten imagenes mayores a 2 Mb!!!");
                return;
            } 
            //console.log(datos);
            this.setState({datos:datos});
        }
        
    }
    



    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);


		return (
            <Segment style={margenes} >
                 
                <Cursoplay
            
                    onSeek={this.onSeek}
                    curso={this.state.curso}
                    referencia={this.referencia}
                    onAcordionModulo={this.onAcordionModulo}
                    modulos={this.state.modulos}
                    strings={this.props.strings}
                    idTipoContenido={this.state.idTipoContenido}
                    urlContenido={this.state.urlContenido}
                    tituloContenido={this.state.tituloContenido}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    permisos={this.state.permisos}
                    visible={this.state.visible}
                    onVisible={this.onVisible}
                    id={this.state.id}
                    regresar={this.regresar}
                    quiz={this.state.quiz}
                    setQuizResult={this.setQuizResult}
                    renderCustomResultPage={this.renderCustomResultPage}
                    comentarios={this.state.comentarios}
                    showModalComents={this.showModalComents}
                    fechaActual={this.state.fechaActual}
                    handleClick={this.handleClick}
                    videoProgreso={this.videoProgreso}
                    onDuration={this.handleDuration}
                    videoTerminado={this.onVideoTerminado}
                    fechaComentario={this.state.fechaComentario}
                    errorExamen={this.state.err}
                    saveExamen={this.saveExamen} 
                    dataCrucigrama={this.state.dataCrucigrama}
                    dataArray={this.state.dataArray}
                    
                />
            
                <ModalComentarios
            
                    showModal={this.state.showModal}
                    comentarios={this.state.comentarios}
                    handleState={this.handleState}
                    handleStateNewComment={this.handleStateNewComment}
                    customInputFunc={this.customInputFunc}    
                    closeModal={this.closeModalComents}
                    name={this.state.fullName}
                    userId={this.state.userId}
                    addText={this.addText}
                    textComment={this.state.textComment}
                    reply ={this.state.reply}
                    edit={this.state.edit}
                    onReply={this.onReply}
                    onCancelReply={this.onCancelReply}
                    setContent={this.setContent}
                    value={this.state.value}
                    botonComentario={this.state.botonComentario}
                    onReplyDelete={this.handleReplyDelete}
                    onComentarioDelete={this.handleComentarioDelete}
                    onEditar={this.onEditar}
                    onContentEdit={this.onContentEdit}
                    onSaveComent={this.onSaveComent}
                    editReply={this.state.editReply}
                    onEditarReply={this.onEditarReply}
                    onReplyEdit={this.onReplyEdit}    
                    onSaveReply={this.onSaveReply}
                    onChange={this.onChange}
                    datos={this.state.datos}

                />
                

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
   
    return {
          

        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        color:state.color,
        
        strings:state.strings,
        idioma:state.idioma,
        user:state.user
    }

}


function mapDispatchToProps(dispatch){

	return { 
        menuActions:bindActionCreators(menuActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        formularioActions: bindActionCreators(formularioActions, dispatch),
        resultadoexamenActions: bindActionCreators(resultadoexamenActions, dispatch),
        comentariosActions: bindActionCreators(comentariosActions, dispatch),
        contenidoActions: bindActionCreators(contenidoActions, dispatch),
        crucigramapalabrasActions: bindActionCreators(crucigramapalabrasActions, dispatch)
 	};
}



export default connect (mapStateToProps, mapDispatchToProps)(withRouter(withAuthenticator(ManageCursoplay)));